<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ch00_fm03"></a><a id="page_2"></a><em>Also by Mo Hayder</em></p>
<p class="center">BIRDMAN<br/>THE TREATMENT<br/>TOKYO</p>
<p class="centerk"><em>For more information on Mo Hayder and her books, see her website at <span class="weblink"><a class="nounder" href="http://www.mohayder.net" target="_blank">www.mohayder.net</a></span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03.vue?7e167b60